import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import {
  PerksForBrandsByTicker,
  PerksForOwningBrands,
} from "@tiicker/util/lib/contentful/queries";
import {
  ContentfulContentType,
  PerkDocument,
} from "@tiicker/util/lib/contentful/types";
import SwiperCarousel from "components/Carousel/SwiperCarousel";
import React from "react";
import { useContentfulEntries } from "source/contentful/provider";
import styles from "./InsightsPerkCarousel.module.scss";
import PerkCard from "components/core/PerkCard/PerkCard";

type Props = {
  tickerSymbols: string[];
};

const InsightsPerkCarousel = (props: Props) => {
  const owningPerks = useContentfulEntries<PerkDocument>(
    ContentfulContentType.Perk,
    {
      query: PerksForOwningBrands(props.tickerSymbols),
    }
  );
  const brandsPerks = useContentfulEntries<PerkDocument>(
    ContentfulContentType.Perk,
    {
      query: PerksForBrandsByTicker(props.tickerSymbols),
    }
  );

  if (owningPerks.state !== "DONE" || brandsPerks.state !== "DONE") {
    return <></>;
  }

  // Combine all the perks into one and filter out any potential duplicates
  const perks =
    owningPerks.state === "DONE" && brandsPerks.state === "DONE"
      ? owningPerks.result.items.concat(
          brandsPerks.result.items.filter(
            (x) => !owningPerks.result.items.some((y) => y.sys.id === x.sys.id)
          )
        )
      : [];

  return (
    <SwiperCarousel
      slides={perks.map((perk, i) => {
        const image =
          getImageReference(perk.fields.image, brandsPerks.result.includes) ??
          getImageReference(perk.fields.image, owningPerks.result.includes);
        const brandLogo =
          getImageReference(
            perk.fields.brand.fields.companyLogoDark,
            brandsPerks.result.includes
          ) ??
          getImageReference(
            perk.fields.brand.fields.companyLogoDark,
            owningPerks.result.includes
          );

        return (
          <div className={styles.overlayContainer}>
            {perk.fields.perkType === "Coming Soon" && (
              <>
                <div className={styles.overlayColor} />
                <p className={styles.currentSelectionOverlay}>Coming Soon</p>
              </>
            )}
            <PerkCard
              id={perk.sys.id}
              imageUrl={image?.fields.file.url ?? ""}
              title={perk.fields.title}
              noAnimate
              brandLogo={brandLogo?.fields.file.url ?? ""}
              tickerSymbol={perk.fields.brand.fields.tickerSymbol ?? ""}
              cardClassName={styles.perkCard}
              imageClassName={styles.perkCard_image}
              className={styles.card}
              limitedQuantityNumber={perk.fields.limitedQuantityNumber}
              perkType={perk.fields.perkType ?? undefined}
            />
          </div>
        );
      })}
      pagination={perks.length < 13}
      navigation
      spaceBetween={32}
      slidesPerGroup={2}
      slidesPerView={2}
      slideClass={styles.slide}
      swiperClass={styles.swiper}
      openSide="both"
      breakPoints={{
        1000: {
          slidesPerGroup: 2,
          slidesPerView: 2,
        },
        768: {
          slidesPerGroup: 1,
          slidesPerView: 1,
        },
        100: {
          slidesPerGroup: 1,
          slidesPerView: 1,
        },
      }}
    />
  );
};

export default InsightsPerkCarousel;
